module.exports = __webpack_public_path__ + "static/img/on_MRO.37edb77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main/on_MRO.png
// module id = LHOa
// module chunks = 1